import css from 'styled-jsx/css';

import { gradient } from 'common/styling/theme';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  :global(.WalletTypeButton__inner) {
    width: 30%;
    margin: rem(0 25px 25px 0);
    &:nth-child(3n) {
      margin-right: 0;
    }
    @include respond-to(xl) {
      &:nth-child(3n) {
        margin: rem(0 25px 25px 0);
      }
    }
    @media only screen and (max-width: 1200px) {
      width: 49%;
      margin: rem(0 0 20px 0);
      &:nth-child(3n) {
        margin: rem(0 0 20px 0);
      }
      &:nth-child(2n) {
        margin-right: 0;
      }
    }
    @include respond-to(xs) {
      width: 100%;
    }
    :global(.Tooltip__text) {
      width: 100%;
    }
  }

  .WalletTypeButton {
    position: relative;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.06);
    padding: 24px;
    cursor: pointer;
    position: relative;
    width: 100%;
    &:hover {
      .WalletTypeButton__hover {
        opacity: 1;
        transform: scale(1);
      }
    }
    &:disabled {
      cursor: not-allowed;
      .WalletTypeButton__hover {
        display: none;
      }

      &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: #000;
        opacity: 0.25;
        border-radius: 6px;
      }
    }
  }

  .WalletTypeButton__logo {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: rem(60px);
    height: rem(60px);
    font-size: rem(32px);
    font-weight: 500;
    margin-right: rem(20px);
    text-transform: uppercase;
  }

  .WalletTypeButton__text-inner {
    width: calc(100% - 85px);
    @include respond-to(sm) {
      width: calc(100% - 75px);
    }
  }

  .WalletTypeButton__caption {
    margin-bottom: 10px;
    height: rem(25px);
    overflow: hidden;
    text-align: left;
  }

  .WalletTypeButton__description {
    font-size: 13px;
    line-height: 18px;
    height: rem(88px);
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left !important;
    :global(p) {
      text-align: left !important;
    }
  }

  .WalletTypeButton__hover {
    opacity: 0;
    position: absolute;
    transform: scale(0.9);
    cursor: pointer;
    transition: all 0.4s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    :global(span) {
      text-transform: uppercase;
      font-size: rem(18px);
      font-weight: 700;
      letter-spacing: 2px;
    }
  }
`;

const getDynamicStyles = ({ colors, border }) => {
  return css`
    .WalletTypeButton {
      background-color: ${colors.white.hex};
      border-radius: 6px;
      &:disabled {
        .WalletTypeButton__logo {
          background: ${colors.lightGray.hex};
        }
      }
    }

    .WalletTypeButton__caption {
      color: #074a6c;
    }

    .WalletTypeButton {
      &:disabled {
        .WalletTypeButton__caption {
          color: #c7c7c7;
        }
      }
    }

    .WalletTypeButton__logo {
      background: ${gradient(53.07, [colors.gradientStart.rgb, 1], 0, [colors.gradientEnd.rgb, 1], 100)};
      color: ${colors.white.hex};
    }

    .WalletTypeButton__description {
      color: ${colors.gray.hex};
    }

    .WalletTypeButton__hover {
      background: ${gradient(53.07, [colors.gradientStart.rgb, 0.85], 0, [colors.gradientEnd.rgb, 0.85], 100)};
      border-radius: 6px;
      :global(span) {
        color: ${colors.white.hex};
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
